import { Context, PlayerGame, Screen } from 'state-machines/just-multi-game/types';
import { PerformanceBucket } from 'types/configs';
import { ChampionshipGame } from 'types/generated-types';
import { getMarketingCloudVisitorID } from 'utils/heartbeatWrapper';
import { mgMetadataBase } from './useMultiGameLayout';

export function getMaxStreams(bucket: PerformanceBucket): number {
  if (bucket === PerformanceBucket.HighEnd) return 3;
  else if (bucket === PerformanceBucket.Average) return 2;
  return 1;
}

export function getIsMultiGameFull(context: Context): boolean {
  return context.screens.length >= context.maxStreams;
}
export function getIsInMultiGame(context: Context, bracketId: number): boolean {
  return context.screens.findIndex((item) => item.bracketId === bracketId) > -1;
}

export function getIsPrimary(context: Context, bracketId: number): boolean {
  return context.screens.find((item) => item.bracketId === bracketId)?.isPrimary ?? false;
}

export function getPrimaryGameId(context: Context): number | undefined {
  return context.screens.find((item) => item?.isPrimary)?.bracketId;
}

export function getPrimarySessionId(context: Context): string | undefined {
  return context.screens.find((item) => item?.isPrimary)?.sessionName;
}

export function getDefaultActiveScreens(liveGames: number[], max: number): PlayerGame[] {
  const retValue: PlayerGame[] = [];
  let isPrimary = true;
  for (const liveGame of liveGames) {
    if (retValue.length < max) retValue.push({ bracketId: liveGame, isPrimary: isPrimary });
    isPrimary = false;
  }
  return retValue;
}

export function convertNumberToScreenEnum(value: number): Screen {
  return value === 4 ? Screen.Four : value === 3 ? Screen.Three : value === 2 ? Screen.Two : Screen.One;
}

export function getAlerts(game: ChampionshipGame) {
  const alerts = [] as string[];

  if (game.hasExcitementAlert && game.excitementAlerts)
    game.excitementAlerts.forEach((ea) => {
      if (ea?.alertTypeName && !alerts.includes(ea?.alertTypeName)) alerts.push(ea.alertTypeName);
    });
  return alerts.join(',');
}

export function getMGMetaDataBase(
  activeScreenCount: number,
  createDate: number,
  isFullScreenActive: boolean,
  isHeroSizeActive: boolean,
  isPrimary: boolean,
  isTheater: boolean,
): mgMetadataBase {
  const metaData = {
    multiViewMode: isPrimary
      ? isFullScreenActive
        ? 'fullscreen'
        : 'primary'
      : isFullScreenActive
        ? 'background'
        : 'secondary',
    multiDisplay: isTheater ? 'theater' : 'default',
    multiStreams: activeScreenCount.toString(),
    multiLayout: isHeroSizeActive ? 'alternate' : 'equal',
    videoSessionId: `${getMarketingCloudVisitorID()}_${createDate}`,
  };
  return metaData;
}
